import DirectSaleReportDataView from './directSaleReport/dataView';

export default {
  'directSaleReport/dataView': DirectSaleReportDataView,
};
